import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'react-router-redux'
import { OidcProvider } from 'redux-oidc'

import 'sanitize.css/sanitize.css'
import './index.css'

import App from './containers/app'
import userManager from './containers/login/userManager'
import { unregister } from './registerServiceWorker'
import createStore, {createHistory} from './store'

const target = document.querySelector('#root')

function resolveTenantFromUrl() {
  const pathname = window.location.pathname

  // Login callback is tenant-free: Okta redirect_uri has no tenant prefix.
  // The callback page renders with basename: '', which means app routes like
  // /pools won't match — but that's fine because the success/error handlers
  // do a full window.location.href navigation (not a React Router push),
  // triggering a full page reload that re-initialises with the correct basename.
  if (pathname.startsWith('/login/callback')) {
    return { basename: '' }
  }

  const env = window.env || {}
  const tenants = env.tenants || []
  const pathSegments = pathname.split('/').filter(Boolean)
  const firstSegment = pathSegments[0]

  if (firstSegment && tenants.indexOf(firstSegment.toLowerCase()) !== -1) {
    const tenant = firstSegment.toLowerCase()
    return { basename: '/' + tenant, tenant: tenant }
  }

  // No tenant in URL — redirect preserving the current path
  let defaultTenant = localStorage.getItem('tenant')
  if (defaultTenant !== null) {
    defaultTenant = defaultTenant.toLowerCase()
  }
  if (defaultTenant === null || tenants.indexOf(defaultTenant) === -1) {
    defaultTenant = tenants[0]
  }
  if (!defaultTenant) {
    console.error('No tenants configured in window.env.tenants')
    const root = document.querySelector('#root')
    if (root) {
      root.innerHTML = '<div style="padding:20px;color:#c00">Configuration error: No tenants available. Check window.env.tenants.</div>'
    }
    return null
  }
  const redirectPath = '/' + defaultTenant + pathname + window.location.search + window.location.hash
  window.location.replace(redirectPath)
  return null
}

const resolved = resolveTenantFromUrl()

if (resolved) {
  const store = createStore(resolved.basename)
  // History is already created with the correct basename inside createStore
  const history = createHistory()

  unregister()

  ReactDOM.render(
    <Provider store={store}>
      <OidcProvider store={store} userManager={userManager}>
        <ConnectedRouter history={history}>
          <div>
            <App store={store} />
          </div>
        </ConnectedRouter>
      </OidcProvider>
    </Provider>,
    target
  )
}



// WEBPACK FOOTER //
// ./src/index.js